import {
  Box,
  ToggleButton,
  ToggleButtonGroup,
  ToggleButtonGroupPropsColorOverrides,
  Typography,
} from "@mui/material";
import React from "react";
import { Trans } from "@lingui/macro";
import { OverridableStringUnion } from "@mui/types";

type Props = {
  value: "metric" | "imperial" | "custom";
  onChange?: (event: React.MouseEvent<HTMLElement, MouseEvent>, value: any) => void;
  hideCustom?: boolean;
  hideUomText?: boolean;
  // once we update settings to have consistent design, we can remove toggleGroupColor prop
  toggleGroupColor?: OverridableStringUnion<
    "standard" | "primary" | "secondary" | "error" | "info" | "success" | "warning",
    ToggleButtonGroupPropsColorOverrides
  >;
  showBorder?: boolean;
};

const UnitPreferenceToggle = ({
  value,
  onChange,
  hideCustom,
  hideUomText,
  toggleGroupColor = "info",
  showBorder = true,
}: Props) => {
  return (
    <Box borderTop={showBorder ? "1px solid" : "none"} borderColor="divider" pt={3}>
      {!hideUomText && (
        <Typography variant="prose-sm" mb={1} color="text.primary" sx={{ display: "block" }}>
          <Trans>Unit of measure</Trans>
        </Typography>
      )}
      <ToggleButtonGroup
        exclusive
        value={value}
        fullWidth
        onChange={onChange}
        color={toggleGroupColor}
      >
        <ToggleButton
          value="metric"
          data-testid="metricToggle"
          sx={{
            borderRadius: 2,
          }}
        >
          <Typography variant="ui-sm" color="primary">
            <Trans>Metric</Trans>
          </Typography>
        </ToggleButton>
        <ToggleButton
          value="imperial"
          data-testid="imperialToggle"
          sx={{
            borderRadius: 2,
          }}
        >
          <Typography variant="ui-sm" color="primary">
            <Trans>Imperial</Trans>
          </Typography>
        </ToggleButton>
        {!hideCustom && (
          <ToggleButton
            value="custom"
            data-testid="customToggle"
            sx={{
              borderRadius: 2,
            }}
          >
            <Typography variant="ui-sm" color="primary">
              <Trans>Custom</Trans>
            </Typography>
          </ToggleButton>
        )}
      </ToggleButtonGroup>
    </Box>
  );
};

export default UnitPreferenceToggle;
